import { useTranslate as usePolyglotTranslate } from 'react-polyglot';

import type { t } from 'react-polyglot';

export default function useTranslate(): t {
  return usePolyglotTranslate() as t;
}
